import { RootState } from "@/redux/store";
import { routes } from "@/routes/utils";
import { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import {
  FAIL_STATUS,
  quickInsightsBaseData,
  stageBaseData,
} from "../consts";

const useAuditTrailView = () => {
  const { auditTrailDtl } = useSelector((state: RootState) => state.currentData);

  const breadcrumbData = useMemo(
    () => [
      {
        link: `/${routes.bom}/${routes.finance}`,
        name: `Activity Dashboard`,
      },
      {
        link: `/${routes.bom}/${routes.finance}/${routes.audit}`,
        name: <span className="text-primary">{"Audit"}</span>,
      },
      {
        link: `/${routes.bom}/${routes.finance}/${routes.auditTrail}`,
        name: <span className="text-primary">{"Audit Trail"}</span>,
      },
      {
        link: "",
        name: `${[...quickInsightsBaseData, ...stageBaseData]?.find((item: any) => item.stage == auditTrailDtl?.stage)?.title || ""} Details`
      },
    ],
    [auditTrailDtl]
  );

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  
  const isFailStatus = useMemo(() => auditTrailDtl?.processingStatus === FAIL_STATUS, [auditTrailDtl]);

  return {
    breadcrumbData,
    isFailStatus,
    pageTitle: breadcrumbData[breadcrumbData.length - 1]?.name || "",
    auditTrailData: auditTrailDtl
  };
};

export default useAuditTrailView;
